import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReelsService } from '../../../../services/reels.service';
import { SwalService } from '../../../../shared/services/swal.service';

@Component({
	selector: 'app-evidences',
	styleUrls: ['./evidences.component.scss'],
	templateUrl: './evidences.component.html'
})
export class EvidencesComponent implements OnInit {
	reelId: number;
	medias: any[] = [];
	images: any[] = [];
	displayEvidence = false;

	responsiveOptions: any[] = [
		{
			breakpoint: '1024px',
			numVisible: 5
		},
		{
			breakpoint: '768px',
			numVisible: 3
		},
		{
			breakpoint: '560px',
			numVisible: 1
		}
	];

	constructor(
		private route: ActivatedRoute,
		private reelService: ReelsService,
		private swal: SwalService,
	) {
		this.route.params.subscribe(params => {
			this.reelId = +params['id'];
			/* this.reelService.getEvidences(this.reelId).subscribe((data: any) => {
				this.medias = data.response;
			});*/

		});
	}
	ngOnInit(): void {
	}

	/**
	 * Load evidence data or alert the user that this media does not contain any evidence
	 * @param media
	 */
	openEvidence(media): void {
		this.images = [];
		this.displayEvidence = false;
		if (media.evidences?.length > 0) {
			this.images = media.evidences;
			this.displayEvidence = true;
		} else {
			this.swal.warning({
				text: 'Este media no cuenta con evidencias guardadas',
				icon: 'info',
				title: 'Atención',
				showCancelButton: false,
				confirmButtonText: 'Ok'
			});
		}
	}

}
